export default __webpack_public_path__ + "static/media/tg.995568db.svg";